import React from "react";
import { Regexes } from "Utils/Regexes";

export const clickifyPhoneNumber = (message) => {
  var phoneMatches = message?.match(Regexes.RESPONSE_MESSAGE_PHONE);
  if(phoneMatches) {
    var temp = message.split(phoneMatches[0]);
    var ref = `tel:+${phoneMatches[0].replace(/-/g, '')}`;
    var tel = <a href={ref} className="phone-number click-support-phone-number">{phoneMatches[0]}</a>;
    if (temp[1]) {
      return <span>{temp[0]} {tel} {temp[1]}</span>;
    } else {
      return <span>{tel}.</span>;
    }
  } else {
    return message;
  }
}

export function findDefaultBank(bankArray) {
  if (!bankArray) return null;
  var defaultBank = bankArray.find((element) => {
    return element.defaultAccountNumber === "true";
  });
  return defaultBank || bankArray[0];
}

export function capitalizeFirstLetter(string) {
  if(!string) return '';
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

export function mask(str, n = 4) {
  return str.substring(str.length - n);
}

export function endingIn(val) {
  if (val) {
    return ` ending in ${val}`;
  } else {
    return '';
  }
}

export function FindMatchedFundingSource(fundList, selectedFund) {
  if (!fundList) return null;
  var bank = fundList.find((element) => {
    return element.accountNumber === selectedFund.accountNumber && element.routingNumber === selectedFund.routingNumber;
  });
  return bank || fundList[0];
}

export function AddTrailingZeros(amount) {
  if (!amount) return amount;
  if (amount.toString().indexOf('.') < 0) return amount + ".00";
  let parts = amount.toString().split('.');
  switch (parts[1].length) {
    case 0:
      return amount + "00";
    case 1:
      return amount + "0"
    default:
      return amount;
  }
}